import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5090Service } from '../../CSPService/CSP5090/csp5090.service';
import { Csp5090Class } from '../../CSPClass/CSP5090/csp5090-class';
@Component({
  selector: 'kt-csp5090-view',
  templateUrl: './csp5090-view.component.html',
  styleUrls: ['./csp5090-view.component.scss']
})
export class Csp5090ViewComponent implements OnInit {

   lblPageTitle: string = "";
  DepositsList: any[] = []; 
  showDepositsInfo = false;


  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5090ViewComponent>, private objCsp5090Service:Csp5090Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
     this.onGetDatas();
  }

   onGetDatas() {
   if (localStorage.getItem('currentUser') != null) {
    var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
    var classobj = new Csp5090Class();
     classobj.UserNam= userLoginDetails.UserNam;
     this.objCsp5090Service.Deposits(classobj).subscribe((data) => {           
     this.DepositsList = data || []; 
     });
       this.changeDetectorRef.detectChanges();
  }
}

indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}

//Total Calculations for Deposits  Fee Tab

OtherFeeTotalAmountToPay(): number {
  return this.DepositsList.reduce((sum, item) => {
    const value = Number(String(item.FeeAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountPaid(): number {
  return this.DepositsList.reduce((sum, item) => {
    const value = Number(String(item.PaidAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountDue(): number {
  return this.DepositsList.reduce((sum, item) => {
    const value = Number(String(item.amount_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OtherFeeTotalAmountRepay(): number {
  return this.DepositsList.reduce((sum, item) => {
    const value = Number(String(item.repay_amount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
  
}
//End of Total Calculations for Deposits Fee Tab
  onClose() {
  if (this.dialogRef) {
    this.dialogRef.close();
  }
}
   getComponentTitle() {
    let result =  "Deposits";
    return result;
   }
}
